var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _path5, _path6, _path7, _path8, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 36,
    width: 103.922,
    height: 103.922,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.26
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63184,
    y: 38.6318,
    width: 98.6602,
    height: 55.2497,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.079 108.35H12.093C11.6328 108.35 11.2598 108.939 11.2598 109.665C11.2598 110.392 11.6328 110.981 12.093 110.981H102.079C102.539 110.981 102.912 110.392 102.912 109.665C102.912 108.939 102.539 108.35 102.079 108.35Z",
    fill: "#718095",
    fillOpacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2482 112.295H12.0487C11.613 112.295 11.2598 112.884 11.2598 113.61C11.2598 114.337 11.613 114.926 12.0487 114.926H97.2482C97.6839 114.926 98.0371 114.337 98.0371 113.61C98.0371 112.884 97.6839 112.295 97.2482 112.295Z",
    fill: "#718095",
    fillOpacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4851 116.24H11.9866C11.5852 116.24 11.2598 116.829 11.2598 117.556C11.2598 118.282 11.5852 118.871 11.9866 118.871H90.4851C90.8865 118.871 91.2119 118.282 91.2119 117.556C91.2119 116.829 90.8865 116.24 90.4851 116.24Z",
    fill: "#718095",
    fillOpacity: 0.45
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.706 120.189H12.0903C11.6316 120.189 11.2598 120.778 11.2598 121.505C11.2598 122.231 11.6316 122.82 12.0903 122.82H77.706C78.1647 122.82 78.5366 122.231 78.5366 121.505C78.5366 120.778 78.1647 120.189 77.706 120.189Z",
    fill: "#718095",
    fillOpacity: 0.45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2598,
    y: 97.8281,
    width: 84.19,
    height: 7.89281,
    rx: 1,
    fill: "#AEB6C2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2598,
    y: 125.455,
    width: 24.9939,
    height: 9.20828,
    rx: 1,
    fill: "#AEB6C2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 123.079,
    y: 36,
    width: 103.922,
    height: 103.922,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.26
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 125.711,
    y: 38.6318,
    width: 98.6602,
    height: 55.2497,
    rx: 2,
    fill: "#718095",
    fillOpacity: 0.26
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.159 108.349H129.173C128.713 108.349 128.34 108.938 128.34 109.664C128.34 110.391 128.713 110.98 129.173 110.98H219.159C219.619 110.98 219.992 110.391 219.992 109.664C219.992 108.938 219.619 108.349 219.159 108.349Z",
    fill: "#718095",
    fillOpacity: 0.45
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.328 112.295H129.129C128.693 112.295 128.34 112.884 128.34 113.61C128.34 114.337 128.693 114.926 129.129 114.926H214.328C214.764 114.926 215.117 114.337 215.117 113.61C215.117 112.884 214.764 112.295 214.328 112.295Z",
    fill: "#718095",
    fillOpacity: 0.45
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M207.565 116.24H129.067C128.665 116.24 128.34 116.829 128.34 117.556C128.34 118.282 128.665 118.871 129.067 118.871H207.565C207.967 118.871 208.292 118.282 208.292 117.556C208.292 116.829 207.967 116.24 207.565 116.24Z",
    fill: "#718095",
    fillOpacity: 0.45
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M194.786 120.188H129.17C128.712 120.188 128.34 120.776 128.34 121.503C128.34 122.229 128.712 122.818 129.17 122.818H194.786C195.245 122.818 195.617 122.229 195.617 121.503C195.617 120.776 195.245 120.188 194.786 120.188Z",
    fill: "#718095",
    fillOpacity: 0.45
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 128.339,
    y: 97.8271,
    width: 84.19,
    height: 7.89281,
    rx: 1,
    fill: "#AEB6C2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 128.339,
    y: 125.449,
    width: 24.9939,
    height: 9.20828,
    rx: 1,
    fill: "#AEB6C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.f446c7d1ae7e6c69433feeba9719626f.svg";
export { ForwardRef as ReactComponent };